"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CellLayout = exports.Cell = void 0;

var react_1 = __importDefault(require("react"));

var styles_1 = require("@material-ui/core/styles");

var core_1 = require("@material-ui/core");

var Grid_1 = __importDefault(require("@material-ui/core/Grid"));

var useStyles = styles_1.makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1
    },
    paper: {
      padding: theme.spacing(2),
      color: theme.palette.text.secondary
    }
  };
});

var CellTitle = function CellTitle(props) {
  var title = props.title;

  if (!title) {
    return null;
  }

  return react_1.default.createElement(core_1.Typography, {
    variant: "h5"
  }, title);
};

exports.Cell = function (props) {
  var classes = useStyles();
  var _props$xs = props.xs,
      xs = _props$xs === void 0 ? 12 : _props$xs,
      xl = props.xl,
      _props$sm = props.sm,
      sm = _props$sm === void 0 ? 6 : _props$sm,
      _props$md = props.md,
      md = _props$md === void 0 ? 6 : _props$md,
      lg = props.lg,
      children = props.children,
      title = props.title,
      description = props.description;
  return react_1.default.createElement(Grid_1.default, {
    item: true,
    xs: xs,
    xl: xl,
    sm: sm,
    md: md,
    lg: lg
  }, react_1.default.createElement(core_1.Paper, {
    className: classes.paper
  }, react_1.default.createElement(CellTitle, {
    title: title
  }), description ? react_1.default.createElement("p", null, description) : null, children));
};

exports.CellLayout = function (props) {
  var children = props.children;
  return react_1.default.createElement(Grid_1.default, {
    container: true,
    spacing: 3
  }, children);
};